import { createRouter } from "@tanstack/react-router";
import { queryClient } from "$/modules/shared/lib/query-client";
import { ErrorFallback } from "$/modules/shared/ui/error-fallback";
import { RoutePending } from "$/modules/shared/ui/route-pending";
import { routeTree } from "./routeTree.gen";

export function getRouter() {
	return createRouter({
		routeTree,
		context: { queryClient },
		scrollRestoration: true,
		defaultPreload: "intent",
		defaultPreloadDelay: 50,
		defaultPreloadStaleTime: 0,
		defaultViewTransition: true,
		defaultPendingMs: 250,
		defaultPendingMinMs: 0,
		defaultPendingComponent: RoutePending,
		defaultErrorComponent: ({ error, reset }) => (
			<ErrorFallback error={error} reset={reset} />
		),
		defaultNotFoundComponent: () => <ErrorFallback variant="notFound" />,
	});
}
declare module "@tanstack/react-router" {
	interface Register {
		router: ReturnType<typeof getRouter>;
	}
}
